import { differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';
import { useState, useCallback, useEffect } from 'react';

const useTimer = (endTime: string) => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  const calculateTimeLeft = useCallback(() => {
    const targetDate = new Date(endTime);
    const now = new Date();
  
    if (targetDate > now) {
      const hours = differenceInHours(targetDate, now);
      const minutes = differenceInMinutes(targetDate, now) % 60;
      const seconds = differenceInSeconds(targetDate, now) % 60;
  
      setTimeLeft({ hours, minutes, seconds });
    } else {
      setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
    }
  }, [endTime]);
  
  useEffect(() => {
    if (endTime) {
      calculateTimeLeft();
      const intervalId = setInterval(calculateTimeLeft, 1000);
      return () => clearInterval(intervalId);
    }
  }, [calculateTimeLeft, endTime]);

  return timeLeft;
};

export default useTimer;